import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ModusTooltipModule } from '@trimble-gcs/modus';
import { PropertiesComponent } from '../../options-panel/selected-details/single-selected/properties/properties.component';
import { ScandataModel } from '../../scandata/scandata.models';
import { Scan3dStyle } from '../models/scan-3d-style';
import { Scan3dStyleUom } from '../models/scan-3d-style-uom';
import { Scan3dStylingComponent } from '../scan-3d-styling/scan-3d-styling.component';
import { scan3dDetailTranslations } from './scan-3d-detail.translations';

@UntilDestroy()
@Component({
  selector: 'sd-scan-3d-detail',
  imports: [
    CommonModule,
    MatTabsModule,
    PropertiesComponent,
    Scan3dStylingComponent,
    MatProgressBarModule,
    ModusTooltipModule,
  ],
  templateUrl: './scan-3d-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Scan3dDetailComponent {
  readonly currentModel = input.required<ScandataModel>();
  readonly elevationPicking = input<boolean>(false);
  readonly scan3dStyle = input.required<Scan3dStyle>();
  readonly scan3dStyleUom = input.required<Scan3dStyleUom>();

  readonly exitDetailClick = output();
  readonly styleChange = output<Scan3dStyle>();
  readonly elevationPickingChange = output<boolean>();

  readonly currentModelName = computed(() => this.currentModel().name);

  readonly translations = scan3dDetailTranslations();

  onExitDetailClick() {
    this.exitDetailClick.emit();
  }

  onSelectedTabChange(tab: MatTabChangeEvent) {
    if (tab.index === 0) {
      this.elevationPickingChange.emit(false);
    }
  }

  onStyleChange(style: Scan3dStyle) {
    this.styleChange.emit(style);
  }

  onElevationPickingChange(picking: boolean) {
    this.elevationPickingChange.emit(picking);
  }
}
